import { render } from "./DragRoom.vue?vue&type=template&id=66297e0f&scoped=true"
import script from "./DragRoom.vue?vue&type=script&lang=js"
export * from "./DragRoom.vue?vue&type=script&lang=js"

import "./DragRoom.vue?vue&type=style&index=0&id=66297e0f&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\bm365\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66297e0f"]])

export default __exports__